import React from "react";

interface OnboardFormSkeletonProps {
    rows?: number;
}

export function OnboardFormSkeleton({rows = 4}: OnboardFormSkeletonProps) {
    return (
        <div className="onboardForm onboardFormSkeleton" aria-hidden="true">
            <div className="onboardForm__fields">
                {Array.from({length: rows}).map((_, index) => (
                    <div className="onboardFormSkeleton__field" key={index}>
                        <span className="onboardFormSkeleton__line onboardFormSkeleton__line--input"/>
                    </div>
                ))}
            </div>

            <div className="onboardForm__submit">
                <span className="onboardFormSkeleton__line onboardFormSkeleton__line--button"/>
            </div>
        </div>
    );
}